"use client";
import { ExtractBySectionType, SectionType } from "types";
import { Reveal } from "../reveal";
import { AspectRatio } from "../ui/aspect-ratio";
import { PortableText } from "next-sanity";
import { SanityImage } from "../sanity-image";

type StatsType = ExtractBySectionType<SectionType, "statsSection", "type">;
export function Stats({ data }: { data: StatsType }) {
  const { stats, title, image, description } = data;
  return (
    <section className="py-24 px-8 bg-[linear-gradient(rgba(255,255,255,0.94),rgba(255,255,255,0.94)),url('/index/community/noise.svg')] bg-white">
      <div className="grid grid-cols-12 grid-rows-[auto_auto] gap-4 max-w-screen-lg mx-auto gap-y-8">
        <Reveal className="relative bg-primary-900 before:absolute before:content-[''] before:w-full before:h-full before:bg-center overflow-hidden  before:translate-x-[12%] before:translate-y-[26%]  before:rotate-[-249deg] before:bg-[linear-gradient(rgba(6,_57,_130,_0.43),rgba(6,_57,_130,_0.43)),url('/index/stats/circles.png')] before:bg-cover before:scale-[250%] befere:bg-no-repeat px-4 py-8 text-primary-50 rounded-xl h-full w-full col-span-4  md:row-start-2">
          <h3 className="relative font-medium text-xl lg:text-4xl">
            {stats[0].prefix}
            {stats[0].value}
            {stats[0].suffix}
          </h3>
          <p className="relative text-[rgba(135,_140,_145,_1)] text-xs lg:text-xl">
            {stats[0].label}
          </p>
        </Reveal>
        <Reveal className="flex col-span-8 lg:col-span-12 flex-col lg:grid  lg:grid-cols-12 lg:gap-8 self-center justify-self-center">
          <h4 className="font-medium text-base lg:text-4xl lg:col-span-6">
            {title}
          </h4>
          {description && (
            <PortableText
              value={description}
              components={{
                block: {
                  normal: ({ children }) => {
                    return (
                      <p className="text-xs line-clamp-3 lg:col-span-6 lg:text-base lg:line-clamp-4">
                        {children}
                      </p>
                    );
                  },
                },
              }}
            />
          )}
        </Reveal>
        <div className="w-full col-span-12 md:col-span-8 md:col-start-5">
          <Reveal>
            <AspectRatio ratio={326 / 123}>
              {image && (
                <SanityImage
                  src={image}
                  alt="event"
                  fill
                  placeholder="blur"
                  blurDataURL={image.asset?.metadata?.lqip || ""}
                  className="object-cover rounded-2xl cursor-pointer"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              )}
            </AspectRatio>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
